import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';
import { Document } from '../documents/types';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { _mockDocument } from '../utils/documents.mock';
import { loanDocumentKeys } from 'src/queries/documents/useGetDocument';
import { z } from 'zod';
import { documentSchema } from '../loans/getLoanDocuments';

const GetLoanResponseSchema = z
  .object({
    document: documentSchema,
  })
  .passthrough();

const getDocumentById: QueryFunction<
  Document,
  ReturnType<typeof loanDocumentKeys.byDocument>
> = async ({ queryKey }) => {
  if (isMockServices()) return await mock(_mockDocument);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{
    document: Document;
  }>(`/documents/${queryKey[1]}?include=documentType`, {
    method: 'GET',
  });
  if (!response.data) throw new Error('Failed to fetch loan document by id');

  const validatedDocument = GetLoanResponseSchema.safeParse(response.data);

  if (!validatedDocument.success) {
    const error = validatedDocument.error.format();
    console.error(`Get document by Id validation failed: ${error}`);
    throw new Error(`Failed to parse document: ${queryKey[1]}.`);
  }

  // NOTE: Casting to unknown is a temporary fix until there is a Refactor for proper zod implementation.
  return validatedDocument.data.document as unknown as Document;
};

export default getDocumentById;
